<template>
  <div class="odmik-naroci-televizija">
    <p class="navadno-besedilo">
      T-2 televizija ponuja kar 8 različnih videotek, kjer boste našli vse od filmskih uspešnic, najnovejših
      serij, risank za najmlajše do vsebin za odrasle.
    </p>
    <izdelki-box class="pt-6" v-loading="nalaganjeTvStoritev">
      <izdelek
        v-for="posamezenPaketVideoteka in seznamVideoteke"
        :title="posamezenPaketVideoteka.naziv.toUpperCase()"
        :tag="posamezenPaketVideoteka.vPaketu === 1 ? 'VKLJUČENO V PAKET' : null"
        :key="posamezenPaketVideoteka.idStoritevVrstaIzbira"
      >
        <template v-slot:footer>
          <div class="cena">{{formatPrice(posamezenPaketVideoteka.vPaketu === 1 ? 0 : posamezenPaketVideoteka.cena)}} {{posamezenPaketVideoteka.pricePer}}</div>
          <div class="orderButtonContainer">
            <template v-if="posamezenPaketVideoteka.vPaketu === 0">
              <OrderButton
                v-if="(posamezenPaketVideoteka.vklopljeno === 0 && posamezenPaketVideoteka.odjava_cez === null &&
                  posamezenPaketVideoteka.naroceno === 0 || posamezenPaketVideoteka.vklopljeno === 1 &&
                  posamezenPaketVideoteka.naroceno === 1) && posamezenPaketVideoteka.endDate === null"
                :services="[{serviceId: posamezenPaketVideoteka.id, quantity: 1, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                :service-name="'videoteko ' + posamezenPaketVideoteka.naziv.toUpperCase()"
                style="width: 174px;"
                @orderConfirmed="$emit('orderConfirmed')"
              >
                NAROČI VIDEOTEKO
              </OrderButton>
              <OrderButton
                v-if="
                (posamezenPaketVideoteka.vklopljeno === 1 && posamezenPaketVideoteka.naroceno === 0 && posamezenPaketVideoteka.odjava_cez === null) ||
                (posamezenPaketVideoteka.vklopljeno === 0 && posamezenPaketVideoteka.naroceno === 1)
                 "
                :services="[{serviceId: posamezenPaketVideoteka.id, quantity: 0, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                :service-name="'videoteko ' + posamezenPaketVideoteka.naziv.toUpperCase()"
                style="width: 174px;"
                @orderConfirmed="$emit('orderConfirmed')"
                :disabled="posamezenPaketVideoteka.vklopljeno === 0 && posamezenPaketVideoteka.naroceno === 1"
              >
                {{((posamezenPaketVideoteka.vklopljeno === 0 && posamezenPaketVideoteka.naroceno === 1) ? 'NAROČILO V TEKU' : 'ODJAVI VIDEOTEKO')}}
              </OrderButton>
              <div v-if="posamezenPaketVideoteka.odjava_cez !== null && posamezenPaketVideoteka.endDate === null">
                <el-button type="primary" class="gumb-potrdi" disabled>
                  ODJAVA NA VOLJO ČEZ {{ posamezenPaketVideoteka.odjava_cez }} DNI*
                </el-button>
              </div>
              <div v-if="posamezenPaketVideoteka.endDate !== null">
                <el-button type="primary" class="gumb-potrdi" disabled>
                  VSEBINE NA VOLJO ŠE {{ formatRemainingTime(posamezenPaketVideoteka.endDate) }}
                </el-button>
              </div>
            </template>
            <template v-else>
              <el-button
                :class="posamezenPaketVideoteka.vklopljeno ? 'gumb-crni-okvir' : 'gumb-potrdi'"
                :disabled="posamezenPaketVideoteka.naroceno === 1"
                :loading="posamezenPaketVideoteka.loading"
                @click="narociTvVideoteke(
                  posamezenPaketVideoteka.id,
                  posamezenPaketVideoteka.vklopljeno ? 0 : 1,
                  posamezenPaketVideoteka.naziv,
                  posamezenPaketVideoteka.za_odrasle,
                  posamezenPaketVideoteka
                )"
              >
                {{posamezenPaketVideoteka.vklopljeno ? 'ODJAVI VIDEOTEKO' : (posamezenPaketVideoteka.naroceno ? 'NAROČILO V TEKU' : 'VKLOPI VIDEOTEKO')}}
              </el-button>
            </template>
          </div>
          <div v-if="posamezenPaketVideoteka.vPaketu === 1" class="rednaCena">Redna cena: {{formatPrice(posamezenPaketVideoteka.cena)}} {{posamezenPaketVideoteka.pricePer}}</div>
        </template>
        <div class="px-2" style="text-align: justify;">{{posamezenPaketVideoteka.opis}}</div>
        <div v-if="(posamezenPaketVideoteka.id === 4238 || posamezenPaketVideoteka.id === 394 || posamezenPaketVideoteka.id === 398) && prikaziHBOGoLink">
          <el-button type="primary" @click="HBOGOPrijava"
                     class="gumb-potrdi hbo-go"
                     style="display: flex; justify-content: center">
            <img src="/static/img/MojProfil/Icon-open-account-login.png">
            Prijava v Max
          </el-button>
        </div>
      </izdelek>
    </izdelki-box>
    <div style="padding-top: 40px">
      <OrderExistsInfo v-if="hasAnyPendingOrder"/>
      <InfoKomponenta/>
      <InfoKomponentaOdjavaOpozorilo
        v-if="seznamVideoteke !== null &&seznamVideoteke.find(x => x.odjava_cez !== null)"
      />
    </div>
  </div>
</template>
<script>
  import ClientAgent from '../../../../../assets/js/clientAgent.js'
  import { Button, Col, Dialog } from 'element-ui'
  import InfoKomponenta from './InfoKomponenta'
  import jsPDF from 'jspdf'
  import OrderButton from '../../../../UIComponents/OrderButton.vue'
  import OrderExistsInfo from '../../../../UIComponents/OrderExistsInfo.vue'
  import Izdelek from '../../../../UIComponents/Izdelki/Izdelek.vue'
  import IzdelkiBox from '../../../../UIComponents/Izdelki/IzdelkiBox.vue'
  import {SlovenianCurrencyMixin} from '../../../../../assets/js/Helpers/NumberFormatMixin'
  import InfoKomponentaOdjavaOpozorilo from './InfoKomponentaOdjavaOpozorilo.vue'

  export default {
    name: 'TVvideoteke',
    mixins: [SlovenianCurrencyMixin],
    data () {
      return {
        nalaganjeTvStoritev: false,
        seznamPridobljenihPodatkov: [],
        seznamVklopljenih: [],
        uspesnoNarociloHBO: false,
        centerDialogVisible: false,
        pogojiHBO: false,
        podatkiHBO: [],
        idPaketa: 0
      }
    },
    components: {
      InfoKomponentaOdjavaOpozorilo,
      IzdelkiBox,
      Izdelek,
      OrderExistsInfo,
      OrderButton,
      InfoKomponenta,
      jsPDF,
      [Button.name]: Button,
      [Col.name]: Col,
      [Dialog.name]: Dialog
    },
    props: {
      izbranPrikljucek: null,
      seznamVideoteke: null,
      prikaziHBOGoLink: false
    },
    computed: {
      hasAnyPendingOrder () {
        let out = false
        if (Array.isArray(this.seznamVideoteke)) {
          this.seznamVideoteke.forEach((item) => {
            if (item.naroceno === 1) {
              out = true
            }
          })
        }
        return out
      }
    },
    mounted () {
      this.clientAgent = new ClientAgent()
    },
    methods: {
      HBOGOPrijava () {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/storitve/hbo/pridobiHBOGoKodo',
          param,
          null,
          'OdpriHBOGOLink',
          'ErrPridobiHBOGOKodo')
      },
      OdpriHBOGOLink (podatki) {
        window.open(podatki.data.aktivacijskaPovezava)
      },
      ErrPridobiHBOGOKodo (podatki) {
        this.ShowWarningMessage(podatki)
      },
      narociTvVideoteke (izbranPaketId, status, naziv, zaOddrasle, item) {
        item.loading = true
        this.$emit('narociTvVideoteke', izbranPaketId, status, naziv, zaOddrasle)
      },
      formatRemainingTime (endDate) {
        const diffMs = new Date(endDate) - Date.now()
        if (diffMs <= 0) return '0 MINUT'
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
        if (diffDays >= 1) return `${diffDays} DNI`
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
        if (diffHours >= 1) return `${diffHours} UR`
        return `${Math.floor(diffMs / (1000 * 60))} MINUT`
      }
    }
  }
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociTelevizija/TVvideoteka.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelevizija/TVvideoteke.vue